import fetchRetry from 'fetch-retry';
import { useEffect, useState } from 'react';

const f = fetchRetry(fetch);

async function fetchPayers() {
  const payers = await f(`${process.env.FORM_SERVICE_URL}/api/payers/?limit=1000`, {
    method: 'GET',
    retries: 3,
  });
  return payers.json();
}

export default function usePayers() {
  const [payers, setPayers] = useState([]);

  useEffect(() => {
    async function init() {
      const payersResult = await fetchPayers();
      setPayers(
        payersResult.results.map((i) => ({
          id: i.id,
          payer: i.payer,
          displayName: i.display_name,
        })).sort((a, b) => a.displayName.localeCompare(b.displayName)),
      );
    }

    init();
  }, []);

  return payers;
}
